import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Building, CreditCard } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from '../hooks/useTranslation';

const CompanyDetails = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header cartItemCount={0} onCartClick={() => {}} onOrderClick={() => {}} />
      
      <div className="pt-32 pb-20 px-4">
        <div className="max-w-4xl mx-auto">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="mb-8 hover:bg-gray-100"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('backToHome')}
          </Button>

          <h1 className="text-5xl font-bold text-black mb-8">{t('companyDetailsTitle')}</h1>

          <div className="space-y-6">
            {/* Company Information */}
            <Card className="border-2 border-gray-200">
              <CardContent className="p-8">
                <div className="flex items-start space-x-4 mb-6">
                  <Building className="w-8 h-8 text-black mt-1" />
                  <div>
                    <h2 className="text-2xl font-bold text-black mb-4">{t('cdCompanyInfoTitle')}</h2>
                    <div className="space-y-3 text-gray-700">
                      <div>
                        <span className="font-semibold text-black">{t('cdCompanyName')}:</span>
                        <p className="text-lg">SIA „Hermes invest"</p>
                      </div>
                      <div>
                        <span className="font-semibold text-black">{t('cdRegistrationNumber')}:</span>
                        <p className="text-lg">LV42103078050</p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Legal Address */}
            <Card className="border-2 border-gray-200">
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-black mb-4">{t('cdLegalAddress')}</h2>
                <div className="text-gray-700 space-y-1">
                  <p className="text-lg">Vecā ostmala 54, Liepāja, LV-3401, Latvija</p>
                </div>
              </CardContent>
            </Card>

            {/* Banking Information */}
            <Card className="border-2 border-gray-200">
              <CardContent className="p-8">
                <div className="flex items-start space-x-4">
                  <CreditCard className="w-8 h-8 text-black mt-1" />
                  <div>
                    <h2 className="text-2xl font-bold text-black mb-4">{t('cdBankingInfo')}</h2>
                    <div className="space-y-3 text-gray-700">
                      <div>
                        <span className="font-semibold text-black">{t('cdBankName')}:</span>
                        <p className="text-lg">BluOr Bank AS</p>
                      </div>
                      <div>
                        <span className="font-semibold text-black">{t('cdSwiftCode')}:</span>
                        <p className="text-lg font-mono">CBBRLV22</p>
                      </div>
                      <div>
                        <span className="font-semibold text-black">{t('cdAccountNumber')}:</span>
                        <p className="text-lg font-mono">LV32CBBR1124232600010</p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Contact Information */}
            <Card className="border-2 border-gray-200 bg-gray-50">
              <CardContent className="p-8">
                <h2 className="text-2xl font-bold text-black mb-4">{t('cdRestaurantContact')}</h2>
                <div className="space-y-2 text-gray-700">
                  <p className="font-semibold text-lg">Mikado Sushi</p>
                  <p>Liepu iela 9, Liepāja, Latvija</p>
                  <p><a href="tel:+37128717331" className="text-blue-600 underline">+371 28717331</a></p>
                  <p><a href="mailto:ordersmikado@gmail.com" className="text-blue-600 underline">ordersmikado@gmail.com</a></p>
                  <p className="font-semibold mt-4">{t('businessHours')}:</p>
                  <p>{t('monday')}: <span className="text-red-600">{t('closed')}</span></p>
                  <p>{t('tueThu')}: 12:00–21:00</p>
                  <p>{t('friSat')}: 12:00–22:00</p>
                  <p>{t('sunday')}: 12:00–21:00</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CompanyDetails;